import React from "react";
import styled from "styled-components";
import { Container, Row, Col } from "react-bootstrap";

import { Title, Section, Box, Text } from "../../components/Core";
import { device } from "../../utils";

import Features1 from "../../assets/image/ramadan-giving-images/Icon_hand.png";
import Features2 from "../../assets/image/ramadan-giving-images/Icon_work.png";
import Features3 from "../../assets/image/ramadan-giving-images/Icon_calendar.png";
import Features4 from "../../assets/image/ramadan-giving-images/Icon_money.png";

const SectionStyled = styled(Section)`
  padding-top: 47px;
  padding-bottom: 23px;
  border-bottom: ${({ theme }) => `1px solid ${theme.colors.border}`};
  @media ${device.md} {
    padding-top: 87px;
    padding-bottom: 63px;
  }
`;

const FeatureCard = ({ iconImage, title, children, ...rest }) => (
  <Box {...rest}>
    <Box mb={[3, 3, 3, 4]} pb={2}>
      <img src={iconImage} alt="" />
    </Box>
    <Box>
      <Title variant="card" fontSize="24px" mb={3}>
        {title}
      </Title>
      <Text variant="small">{children}</Text>
    </Box>
  </Box>
);

const Feature = () => (
  <>
    {/* <!-- Feature section --> */}
    <SectionStyled>
      <Container>
        <Row className="justify-content-center">
          <Col lg="3" className="mb-5 mb-lg-4">
            <FeatureCard title="Select Campaign" iconImage={Features1}>
              Select campaign you would like to support. There are loads of campaigns to choose from.
            </FeatureCard>
          </Col>
          <Col lg="3" className="mb-5 mb-lg-4">
            <FeatureCard title="Select Automate" iconImage={Features2}>
              Click Automate to start the your Autogiving journey.
            </FeatureCard>
          </Col>
          <Col lg="3" className="mb-5 mb-lg-4">
            <FeatureCard title="Choose Schedule" iconImage={Features3}>
              Choose schedule for 30 days of Ramadan, Last 10 Nights or Laylatul Qadr.
            </FeatureCard>
          </Col>
          <Col lg="3" className="mb-5 mb-lg-4">
            <FeatureCard title="Select Amount" iconImage={Features4}>
              Select the amount you want to donate for each day of the schedule.
            </FeatureCard>
          </Col>
        </Row>
      </Container>
    </SectionStyled>
  </>
);

export default Feature;
